import React from 'react';
import { motion } from 'framer-motion';
import { ChatBubble } from './Icons';
interface FinalCTAProps {
  lang: 'en' | 'es';
}
export function FinalCTA({
  lang
}: FinalCTAProps) {
  const content = {
    en: {
      title: 'Ready to find your perfect car?',
      button: 'Fill Out the Form'
    },
    es: {
      title: '¿Listo para encontrar tu auto perfecto?',
      button: 'Llena el Formulario'
    }
  };
  const t = content[lang];
  const scrollToForm = () => {
    document.getElementById('quote-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-primary px-6 py-24 text-center" data-id="element-8">
      <div className="mx-auto max-w-3xl" data-id="element-9">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10 text-3xl font-bold text-white md:text-5xl" data-id="element-10">
          {t.title}
        </motion.h2>

        <motion.button type="button" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} onClick={scrollToForm} className="inline-flex items-center justify-center gap-3 rounded-full border-2 border-white bg-transparent px-8 py-4 text-lg font-bold text-white transition-colors hover:bg-white hover:text-primary" data-id="element-11">
          <ChatBubble size={24} data-id="element-12" />
          {t.button}
        </motion.button>
      </div>
    </section>;
}